export default "__VITE_ASSET__Cp2IYt25__"